import { OnDeckKegLevelChart, OnTapKegLevelChart } from "../components/Charts";
import { Heading } from "../components/UI/heading";

export default function Dashboard() {
  return (
    <div className="px-5 bg-gray-50 mx-auto h-full w-full">
      <div className="flex flex-col items-start w-full h-full">
        <Heading className="my-2">Dashboard</Heading>
        <div className="flex flex-row justify-between w-full h-fullp-5 mb-4 gap-x-4">
          <div className="w-1/2 border border-primaryColor/15 rounded-md p-2 items-center justify-center">
            <OnDeckKegLevelChart />
          </div>
          <div className="w-1/2 border border-primaryColor/15 rounded-md px-8 py-2 items-start justify-center">
            <OnTapKegLevelChart />
          </div>
        </div>
      </div>
    </div>
  );
}
